export default __webpack_public_path__ + "static/media/icons.bb8c6a1f.svg";